import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import PageAppBar from 'components/PageAppBar'
import MilestoneDataGrid from 'components/MilestoneDataGrid'

// Define the Milestone type based on the API response
interface Milestone {
  id: string
  value: number
  title: string
}

export default function MilestonesPage() {
  const milestones = useLoaderData() as Milestone[]
  const navigate = useNavigate()

  return (
    <PageAppBar pageName="Jalons de Progression">
      <Box
        sx={{
          padding: '1rem',
          height: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Button
            variant="contained"
            onClick={() => navigate('/milestone/create')}
          >
            Créer un Jalon
          </Button>
        </Box>

        <Box sx={{ flexGrow: 1, width: '100%' }}>
          {/* --- UPDATED: Pass the filtered data to the DataGrid --- */}
          <MilestoneDataGrid milestones={milestones} />
        </Box>
      </Box>
    </PageAppBar>
  )
}
